import { DendromapLoader } from '@repo/ui/components/dendromap-loader';
import { lazy, Suspense } from 'react';

const SuperAdminUsersPage = lazy(() =>
  import('@repo/ui/features/super-admin-users/super-admin-users-page').then((module) => ({
    default: module.SuperAdminUsersPage,
  })),
);

export default function SuperAdminUsersStatsRoute() {
  return (
    <Suspense
      fallback={
        <DendromapLoader message="Chargement du tableau Super Admin..." />
      }
    >
      <SuperAdminUsersPage />
    </Suspense>
  );
}
